import { css } from '@emotion/react'
import {
  Alert,
  Heading,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
  VFlow,
} from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'
import { useFlags } from 'config/useFlagsContext'
import { ReactComponent as Consulta } from 'images/historico/icone-consulta.svg'
import { ReactComponent as AnexoArquivosIcon } from 'images/novidades/anexo-arquivos.svg'
import { ReactComponent as ProgramaDignidadeMenstrual } from 'images/novidades/programa-dignidade-menstrual.svg'
import { ReactComponent as AcompanhamentoCondicoesDeSaudeIcon } from 'images/side-menu/acompanhamentos.svg'
import { ReactComponent as AtividadeColetivaIcon } from 'images/side-menu/atividade-coletiva.svg'
import { ReactComponent as GarantiaAcessoIcon } from 'images/side-menu/garantia-acesso.svg'
import { ReactComponent as GestaoGruposExamesIcon } from 'images/side-menu/gestao-municipal.svg'
import { ReactComponent as Atendimento } from 'images/side-menu/lista-de-atendimento.svg'
import { ReactComponent as Relatorios } from 'images/side-menu/relatorios.svg'
import PuericulturaIcon from 'images/soap/ic_puericultura.webp'
import { ReactComponent as SdcIcon } from 'images/suporte-decisao-clinica/health-system-outline.svg'
import { Fragment } from 'react'

import { Carousel, CarouselItem } from '../components/Carousel'
import { NewsGif } from '../components/NewsGif'
import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsImg } from '../components/NewsImg'
import { NewsList } from '../components/NewsList'
import { NewsListItem } from '../components/NewsListItem'
import { NewsParagraph } from '../components/NewsParagraph'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalPanelCincoQuatro() {
  const {
    PILOTO_DIABETES_HIPERTENSAO_LPC_ENABLED,
    PILOTO_PRESCRICAO_CONTROLADA_ENABLED,
    PROGRAMA_DIGNIDADE_MENSTRUAL_ENABLED,
    PAC_EQUIPAMENTO_ENABLED,
  } = useFlags()

  return (
    <Fragment>
      {PAC_EQUIPAMENTO_ENABLED && (
        <NewsHeadingSection
          title='Adição de Exame físico na Antropometria'
          icon={<Consulta css={styles.iconSVG} />}
          id='adicao-do-exame-fisico-na-antropometria-5-4'
        >
          <NewsSectionContent>
            <NewsList style={styles.noPaddingUl}>
              <NewsListItem>
                No <strong>Objetivo</strong> os campos da seção de{' '}
                <strong>Antropometria, Sinais vitais e glicemia capilar</strong> foram separados em{' '}
                <strong>Sinais vitais e glicemia capilar</strong> e <strong>Antropometria</strong>.
              </NewsListItem>
              <NewsList>
                <NewsListItem>
                  Agora em um atendimento individual na seção do <strong>Objetivo</strong> foram{' '}
                  <strong>adicionados novos campos de Exame Físico junto dos campos de Antropometria</strong>, esses
                  campos tem como objetivo receber dados a partir de exames físicos realizados durante um atendimento.
                </NewsListItem>
              </NewsList>
            </NewsList>
            <NewsGif
              src='/static/novidades/5-4_exame_fisico_caminho.webm'
              pausedSrc='/static/novidades/5-4_exame_fisico_caminho_paused.webp'
              alt='Gif mostrando o caminho até os novos campos.'
            />
            <NewsListItem>
              O campo <strong>Avaliação da força muscular</strong> poderá ser registrado posteriormente através do modal
              de <strong>Medições</strong>, na aba de <strong>Exame Físico.</strong>
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_avaliacao_da_forca_muscular.webm'
              pausedSrc='/static/novidades/5-4_avaliacao_da_forca_muscular_paused.webp'
              alt='Gif mostrando a possibilidade de adicionar o campo de avaliação da força muscular diretamente na modal de medições.'
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Cálculo e exibição de Idade corrigida no card de Acompanhamento da criança'
        icon={<img src={PuericulturaIcon} alt='Puericultura' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
        id='calculo-idade-corrigida-card-acompanhamento-crianca-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Em alusão ao Novembro Roxo, mês de conscientização sobre a prematuridade, o sistema passa a contemplar o{' '}
            <strong>cálculo e a exibição</strong> da <strong>Idade corrigida</strong> no card de Acompanhamento da
            Criança, na Folha de Rosto, para <strong>crianças pré-termo</strong>. Essa atualização torna o
            acompanhamento do desenvolvimento infantil mais preciso, considerando simultaneamente a{' '}
            <strong>Idade gestacional</strong> e a <strong>Idade cronológica</strong> informadas.
          </NewsParagraph>
          <NewsParagraph>Principais pontos da funcionalidade:</NewsParagraph>
          <NewsList>
            <NewsListItem>
              Para crianças pré-termo (nascidas <strong>antes de 37 semanas</strong> de Idade gestacional), o sistema
              realiza automaticamente o cálculo da Idade corrigida;
            </NewsListItem>
            <NewsListItem>
              O resultado é exibido no card de <strong>Acompanhamento da criança</strong>;
            </NewsListItem>
            <NewsListItem>
              A informação é apresentada em <strong>semanas</strong> até completar 2 anos e, a partir daí, em{' '}
              <strong>anos e meses</strong>;
            </NewsListItem>
            <NewsListItem>
              O valor é recalculado <strong>automaticamente</strong> sempre que a Idade gestacional for alterada;
            </NewsListItem>
            <NewsListItem>A exibição permanece disponível no card até o cidadão completar:</NewsListItem>
            <NewsList>
              <NewsListItem>
                <strong>2 anos</strong> de Idade cronológica, ou
              </NewsListItem>
              <NewsListItem>
                <strong>3 anos</strong>, quando a Idade gestacional for inferior a 28 semanas.
              </NewsListItem>
            </NewsList>
          </NewsList>
          <NewsImg
            src='/static/novidades/5-4_acompanhamento_crianca_idade_corrigida.webp'
            alt='Exemplo de card de Acompanhamento da criança com a Idade corrigida de 3 meses para 4 semanas.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Melhorias na gestão de Grupos de Exames'
        icon={<GestaoGruposExamesIcon css={styles.iconSVG} />}
        id='melhoria-grupos-exames-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Para garantir que os grupos de exames estejam sempre atualizados e alinhados com a tabela SIGTAP, o módulo
            de Grupos de exames foi aprimorado. Agora, o sistema informará o administrador municipal sempre que um exame
            se tornar inativo dentro de um grupo, facilitando a manutenção e evitando inconsistências no momento da
            solicitação durante o atendimento.
          </NewsParagraph>
          <NewsParagraph>As principais mudanças foram:</NewsParagraph>
          <NewsListItem>
            <strong>Alerta na tela principal</strong>: Uma nova mensagem informativa será exibida no topo da tela,
            listando todos os grupos que contêm exames inativos, permitindo que o administrador identifique rapidamente
            quais grupos precisam de atenção.
          </NewsListItem>
          <NewsListItem>
            <strong>Identificação na listagem</strong>: Os grupos com exames inativos serão sinalizados com a mensagem
            "Contém exames inativos" diretamente na listagem principal.
          </NewsListItem>
          <NewsListItem>
            <strong>Destaque visual dos exames</strong>: Ao expandir um grupo, os exames que não estão mais ativos serão
            exibidos em um tom diferente. Ao passar o cursor do mouse sobre eles, uma mensagem informativa aparecerá:
            "Esse exame está inativo, por isso não está disponível no atendimento."
          </NewsListItem>
          <NewsListItem>
            <strong>Avisos na edição do grupo</strong>: Ao editar um grupo, um alerta será exibido no topo da janela
            caso existam exames inativos. Além disso, os exames em questão estarão claramente identificados, facilitando
            sua remoção ou substituição.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-4_melhorias_grupos_exames.webp'
            alt='Imagem mostrando as melhorias nos grupos de exames.'
          />
          <NewsParagraph>
            Com essas melhorias, a gestão dos grupos de exames se torna mais transparente e eficiente, garantindo que
            apenas exames válidos estejam disponíveis para os profissionais de saúde.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>

      {PILOTO_DIABETES_HIPERTENSAO_LPC_ENABLED && (
        <NewsHeadingSection
          title='Inclusão de condições na lista de problemas/condições com base no histórico clínico'
          icon={<Icon icon='bloodPressureFilled' css={styles.iconSVG} />}
          id='inclusao-condicoes-historico-lpc-5-4'
        >
          <NewsSectionContent>
            <NewsListItem>
              Agora, condições de diabetes e hipertensão existentes no histórico clínico da pessoa que não estejam
              adicionadas na lista de problemas/condições, deverão ser adicionadas à lista de problemas/condições
              obrigatoriamente. O profissional ficará responsável por avaliar se aquela condição deve entrar como ativa
              ou resolvida.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_inclusao_condicoes_historico_lpc.webp'
              pausedSrc='/static/novidades/5-4_inclusao_condicoes_historico_lpc_paused.webp'
              alt='Gif mostrando a inclusão de condições do histórico clínico na LPC'
            />
            <NewsListItem>
              Condições adicionadas com base no histórico não podem ser excluídas, obrigatoriamente devem ser
              adicionadas na lista de problemas/condições.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-4_inclusao_condicoes_historico_lpc_obrigatoriedade.webp'
              alt='Imagem mostrando a obrigatoriedade de inclusão de condições do histórico clínico na LPC.'
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}

      <NewsHeadingSection
        title='Anexo de arquivos no prontuário'
        icon={<AnexoArquivosIcon css={styles.iconSVG} />}
        id='anexo-arquivos-5-4'
      >
        <NewsSectionContent>
          <NewsListItem>
            Agora será possível <strong>anexar alguns tipos de arquivo</strong> no prontuário de um cidadão durante um
            atendimento. O arquivo pode ser anexado no “<strong>Objetivo</strong>” do SOAP e é possível incluir algumas
            informações de identificação do arquivo.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_anexar_arquivo.webp'
            pausedSrc='/static/novidades/5-4_anexar_arquivo_paused.webp'
            alt='Gif mostrando o anexo de um arquivo'
          />
          <NewsListItem>
            Os arquivos anexados podem ser visualizados no <strong>histórico</strong> de atendimentos e na{' '}
            <strong>listagem de arquivos</strong> no “Objetivo” do SOAP, dentro do prontuário do cidadão. Na listagem, é
            possível incluir filtros e ordenar pela data de adição.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_buscar_arquivo.webp'
            pausedSrc='/static/novidades/5-4_buscar_arquivo_paused.webp'
            alt='Gif mostrando a listagem de arquivos, com a inclusão de um filtro e a alteração de ordenação'
          />
          <NewsListItem>
            Para habilitar a funcionalidade, o administrador de instalação deve preparar a{' '}
            <strong>infraestrutura</strong> e configurar a funcionalidade nas{' '}
            <strong>configurações da instalação</strong>.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Atualização da Ficha de notificação de caso suspeito'
        icon={<Consulta css={styles.iconSVG} />}
        id='notificacao-ficha-sinan-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            A ficha de notificação utilizada na finalização dos atendimentos foi atualizada para refletir o modelo mais
            recente, mantendo a padronização para todos os tipos de doenças e agravos.
          </NewsParagraph>
          <NewsParagraph>As principais mudanças foram:</NewsParagraph>
          <NewsListItem>Inclusão de novas doenças e agravos;</NewsListItem>
          <NewsListItem>Remoção de doenças e agravos obsoletos;</NewsListItem>
          <NewsListItem>Correção e padronização dos nomes.</NewsListItem>
          <NewsParagraph>
            Também foi atualizada a estrutura da ficha impressa, com novos campos e melhorias na disposição das
            informações, permitindo um preenchimento mais completo e organizado.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_notificacao_ficha_sinan.webp'
            alt='Imagem exibindo as notificações da Ficha SINAN'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Avaliação do M-CHAT-R na puericultura'
        icon={<img src={PuericulturaIcon} alt='Puericultura' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
        id='mchat-5-4'
      >
        <NewsSectionContent>
          <NewsListItem>
            Agora no atendimento de <strong>Puericultura de crianças de 16 a 30 meses</strong> é possível realizar a
            avaliação do <strong>M-CHAT-R (Modified Checklist for Autism in Toddlers, Revised)</strong>, um instrumento
            de triagem amplamente utilizado para identificar sinais precoces de transtorno do espectro autista (TEA) em
            crianças. Com essa atualização, profissionais da saúde podem aplicar, registrar e analisar os resultados do
            M-CHAT-R diretamente no sistema.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_m_chat_r_puericultura.webp'
            pausedSrc='/static/novidades/5-4_m_chat_r_puericultura_paused.webp'
            alt='Gif mostrando como acessar o M-CHAT-R através da puericultura e o preenchimento do instrumento.'
          />
          <NewsListItem>
            O último resultado avaliado ficará disponível na puericultura, podendo ser impresso em formato PDF.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_m_chat_r_posterior_puericultura.webp'
            pausedSrc='/static/novidades/5-4_m_chat_r_posterior_puericultura_paused.webp'
            alt='Gif mostrando um resultado do M-CHAT-R em um atendimento posterior ao preenchimento e como imprimir esse resultado a partir da puericultura.'
          />
          <NewsListItem>
            Ainda os demais resultados avaliados durante o atendimento de puericultura, ficarão disponíveis na modal de
            Acompanhamento da criança, podendo ser impressos em formato PDF a qualquer momento.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_m_chat_r_acompanhamento_da_crianca.webp'
            pausedSrc='/static/novidades/5-4_m_chat_r_acompanhamento_da_crianca_paused.webp'
            alt='Gif mostrando a modal de acompanhamento da criança com vários resultados do M-CHAT-R na listagem e como imprimir um desses resultados.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novas funcionalidades para o Acompanhamento de condições de saúde'
        icon={<AcompanhamentoCondicoesDeSaudeIcon css={css(styles.iconSVG, styles.fillableIconSVG)} />}
        id='acompanhamento-condicoes-saude-5-4'
      >
        <NewsSectionContent>
          <Alert type='info' inline>
            Iniciamos uma mudança gradual do termo{' '}
            <Text color='info' fontWeight='bold'>
              Cidadão
            </Text>{' '}
            para o termo{' '}
            <Text color='info' fontWeight='bold'>
              Pessoa
            </Text>{' '}
            no sistema, o módulo de{' '}
            <Text color='info' fontWeight='bold'>
              Acompanhamento de condições de saúde
            </Text>{' '}
            agora utiliza a nova terminologia.
          </Alert>
          <Heading level={4}>Listagens temáticas</Heading>
          <NewsParagraph>
            O módulo de Acompanhamento de condições de saúde foi aprimorado com Listagens temáticas, permitindo a busca
            por diversas condições específicas, como:
          </NewsParagraph>
          <NewsListItem>Gestação e puerpério;</NewsListItem>
          <NewsListItem>Pessoa idosa;</NewsListItem>
          <NewsListItem>Desenvolvimento infantil;</NewsListItem>
          <NewsListItem>Diabetes;</NewsListItem>
          <NewsListItem>Hipertensão;</NewsListItem>
          <NewsListItem>Saúde da mulher;</NewsListItem>
          <NewsListItem>Saúde bucal.</NewsListItem>
          <NewsParagraph>
            A listagem{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Geral{' '}
            </Text>
            será mantida como padrão inicial, permitindo uma visão ampla das pessoas acompanhadas antes da aplicação de
            filtros temáticos específicos.
          </NewsParagraph>
          <NewsParagraph>
            Todas as listagens apresentarão dados e indicadores de boas práticas na atenção primária à saúde, oferecendo
            maior suporte ao cuidado e à tomada de decisão pelas equipes. Os dados e indicadores são provenientes do
            Prontuário Eletrônico e-SUS APS. A tabela agora permite expansão para visualizar informações detalhadas,
            sendo que cada lista possui suas próprias particularidades.
          </NewsParagraph>
          <Heading level={4}>Geral</Heading>
          <NewsListItem>Implementação de novos campos e reordenação de informações da listagem.</NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_geral.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_geral_paused.webp'
            alt='Gif mostrando como utilizar a lista temática geral.'
          />
          <Heading level={4}>Gestação e puerpério</Heading>
          <NewsListItem>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Gestação e puerpério
            </Text>
            , que permite rastrear as gestantes que possuem gestação ativa no Prontuário Eletrônico, bem como as
            gestantes que entraram em puerpério.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_gestacao_puerperio.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_gestacao_puerperio_paused.webp'
            alt='Gif mostrando como utilizar a lista temática de gestação e puerpério.'
          />
          <Heading level={4}>Pessoa idosa</Heading>
          <NewsListItem>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Pessoa idosa
            </Text>
            , que permite a visualização de boas práticas e o rastreamento das condições de saúde das pessoas com 60
            anos ou mais.
          </NewsListItem>
          <NewsListItem>
            Agora é possível filtrar por pessoas idosas (60 anos ou mais) que tiveram ou não o preenchimento do IVCF-20
            (Índice de Vulnerabilidade Clínico-funcional) no Acompanhamento de condições de saúde. É possível filtrar
            pelo índice, dimensões alteradas e pontuação. É possível também buscar por pessoas idosas que não tiveram o
            formulário preenchido.
          </NewsListItem>
          <NewsListItem>
            O filtro está disponível somente na listagem temática da{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Pessoa idosa
            </Text>{' '}
            na opção de filtros avançados.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_pessoa_idosa.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_pessoa_idosa_paused.webp'
            alt='Gif mostrando como utilizar a lista temática de pessoa idosa.'
          />
          <Heading level={4}>Desenvolvimento infantil</Heading>
          <NewsListItem>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Desenvolvimento infantil
            </Text>
            , que permite rastrear as crianças até 2 anos completos.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_dev_infantil.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_dev_infantil_paused.webp'
            alt='Gif mostrando como utilizar a lista temática de desenvolvimento infantil.'
          />
          <Heading level={4}>Diabetes</Heading>
          <NewsListItem>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Diabetes
            </Text>
            , que permite a visualização de boas práticas e o rastreamento das pessoas que possuem as condições
            relacionadas.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_diabetes.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_diabetes_paused.webp'
            alt='Gif mostrando como utilizar a lista temática de diabetes.'
          />
          <Heading level={4}>Hipertensão</Heading>
          <NewsListItem>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Hipertensão
            </Text>
            , que permite a visualização de boas práticas e o rastreamento das pessoas que possuem as condições
            relacionadas à hipertensão arterial.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_tematica_hipertensao.webm'
            pausedSrc='/static/novidades/5-4_lista_tematica_hipertensao_paused.webp'
            alt='Gif mostrando como utilizar a lista temática de hipertensão.'
          />
          <Heading level={4}>Saúde da mulher</Heading>
          <NewsParagraph>
            Implementação da listagem temática de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Saúde da mulher
            </Text>
            , permite visualizar as boas práticas para pessoas do sexo feminino entre 14 e 69 anos, classificadas em
            grupos de rastreamento conforme os seguintes critérios:
            <NewsList>
              <NewsListItem>
                Rastreamento de Infecções Sexualmente Transmissíveis (IST), que visa olhar para a atenção da saúde
                sexual e reprodutiva: Mulheres entre 14 e 69 anos que receberam atendimento relacionado.
              </NewsListItem>
              <NewsListItem>
                Rastreamento de câncer do colo do útero: Mulheres entre 25 e 64 anos que realizaram ao menos um exame de
                rastreamento.
              </NewsListItem>
              <NewsListItem>
                Rastreamento de câncer de mama: Mulheres entre 50 e 69 anos que realizaram ao menos um exame de
                mamografia.
              </NewsListItem>
            </NewsList>
            Essa listagem permitirá um acompanhamento mais eficiente e direcionado, contribuindo para a prevenção e o
            cuidado contínuo dessas mulheres.
          </NewsParagraph>
          <NewsGif
            src='/static/novidades/5-4_lista_saude_mulher.webp'
            pausedSrc='/static/novidades/5-4_lista_saude_mulher_paused.webp'
            alt='Gif mostrando a seleção da lista temática de saúde da mulher, a pesquisa e o resultado'
          />
          <Heading level={4}>Saúde bucal</Heading>
          <NewsListItem>
            Implementação da listagem temática de <strong>Saúde bucal</strong>, que permite a visualização de boas
            práticas e o rastreamento de cidadãos que possuam condições relacionadas.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_lista_saude_bucal.webp'
            pausedSrc='/static/novidades/5-4_lista_saude_bucal_paused.webp'
            alt='Gif mostrando a seleção da lista temática de saúde bucal, a pesquisa e o resultado'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novas funcionalidades para o Cuidado compartilhado'
        icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
        id='novas-funcionalidades-cuidado-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O módulo de Cuidado Compartilhado foi atualizado com recursos que tornam o acompanhamento mais eficiente e
            alinhado à rotina das equipes. Entre as novidades, destacam-se melhorias na contagem de tempo de resposta e
            a introdução de notificações visuais para sinalizar novas evoluções nos cuidados.
          </NewsParagraph>
          <NewsParagraph>
            A contagem de tempo dos cuidados compartilhados foi atualizada para ser pausada no período entre sexta-feira
            às 17:59 até segunda-feira às 00:01.
          </NewsParagraph>
          <NewsParagraph>
            Além disso, para facilitar o acompanhamento dos profissionais em cuidados compartilhados nos quais atuam
            como solicitantes ou executantes, o módulo passou a contar com notificações visuais em tempo real no menu
            lateral e na lista de cuidados. Agora, sempre que houver novos cuidados ou evoluções ainda não visualizadas,
            será exibido um contador no menu lateral, ao lado do item “Gestão de filas”.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_notificacao_cuidado_menu_lateral.webp'
            alt='Imagem exibindo as notificações de Cuidado compartilhado no menu lateral'
          />
          <NewsParagraph>
            Dentro do módulo, os registros com novidades não visualizadas também serão destacados na listagem,
            facilitando a identificação rápida.
          </NewsParagraph>
          <NewsListItem>
            Contadores nas abas: As abas agora exibem um contador próprio, indicando o número exato de itens não lidos
            em cada seção.
          </NewsListItem>
          <NewsListItem>
            Novo filtro: Adicionado a opção "Ver somente solicitações com notificação", permitindo a filtragem da lista
            para trazer apenas itens com notificação.
          </NewsListItem>
          <NewsParagraph>O que gera notificação:</NewsParagraph>
          <NewsListItem>Criação de um novo cuidado com executante definido;</NewsListItem>
          <NewsListItem>
            Criação de um cuidado sem executante, gerando notificação para todos os profissionais da unidade com o CBO
            compatível;
          </NewsListItem>
          <NewsListItem>
            Evolução de um cuidado com alteração no status (por exemplo, de “Respondido” para “Aguardando”).
          </NewsListItem>
          <NewsParagraph>
            O que encerra a notificação:
            <NewsList>
              <NewsListItem>No menu lateral:</NewsListItem>
              <NewsList>
                <NewsListItem>Ao acessar o módulo com notificações pendentes.</NewsListItem>
              </NewsList>
              <NewsListItem>Dentro do módulo:</NewsListItem>
              <NewsList>
                <NewsListItem>
                  Quando o profissional acessa o cuidado (visualiza, discute o caso ou torna-se executante).
                </NewsListItem>
                <NewsListItem>Quando outro profissional se torna responsável pelo cuidado.</NewsListItem>
              </NewsList>
            </NewsList>
          </NewsParagraph>
          <NewsParagraph>Veja como será exibido:</NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_notificacao_cuidado_lista.webp'
            alt='Imagem exibindo as notificações de Cuidado compartilhado na listagem'
          />
          <NewsList>
            <VFlow vSpacing={0.5}>
              <VFlow vSpacing={0.5}>
                <NewsListItem>
                  Criação de tratamento para cuidados compartilhados de cidadãos falecidos, com as seguintes
                  atualizações:
                </NewsListItem>
                <NewsList>
                  <NewsListItem>
                    Ao acessar o cuidado pelo botão "Visualizar discussão", será exibida uma mensagem informando que o
                    cidadão faleceu.
                  </NewsListItem>
                  <NewsListItem>
                    Cuidados com status "Respondido" serão alterados automaticamente para o novo status "Finalizado por
                    óbito".
                  </NewsListItem>
                  <NewsListItem>
                    O botão "Discutir" será desativado em cuidados com o status "Finalizado por óbito".
                  </NewsListItem>
                  <NewsListItem>
                    Cuidados de cidadãos falecidos com o status "Aguardando" permitirão apenas a conduta de "Recondução
                    de cuidado".
                  </NewsListItem>
                </NewsList>
              </VFlow>
            </VFlow>
          </NewsList>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novo relatório para monitoramento de envios para a RNDS'
        id='relatorio-envio-sucesso-rnds-5-4'
        icon={<Relatorios css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora é possível gerar relatórios de envios da RNDS que foram realizados com sucesso. O propósito da
            funcionalidade é possibilitar que os Administradores municipais tenham acesso ao envios que foram feitos com
            sucesso para a RNDS.
          </NewsParagraph>
          <NewsParagraph>
            Em conjunto ao lançamento do relatório de sucesso realizou-se adaptações nas telas de envio da RNDS que
            possui o caminho "Gestão municipal {'>'} aba 'RNDS'" e poderá ser acessado por usuários com o perfil de
            "Administrador municipal". As opções de geração do relatório são:
          </NewsParagraph>
          <NewsListItem>"Status da tentativa de envio" com as opções: "Com erros" e "Com sucesso";</NewsListItem>
          <NewsListItem>"Período do relatório";</NewsListItem>
          <NewsListItem>"Tipo de registro": RIAC, RIAR, RAC e RPM;</NewsListItem>
          <NewsListItem>Botões "Cancelar" e "Gerar relatório".</NewsListItem>
          <NewsImg src='/static/novidades/5-4_tela_rnds.webp' alt='Imagem da tela da RNDS' />
          <NewsParagraph>
            Ao clicar no botao "Gerar relatório" a tabela "Relatórios em processamento/processados (7 dias)" exibirá uma
            nova linha com o relatório, em caso de sucesso será possível exportar a planilha com as informações
            solicitadas pelo usuário.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_tabela_relatorios_processados_rnds.webp'
            alt='Imagem da tela da RNDS e da tabela de relatórios processados'
          />
          <NewsParagraph>
            O relatório deve conter um resumo das informações inseridas pelo usuário nos campos "Status da tentativa de
            envio", "Período do relatório" e "Tipo de registro".
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_relatorio_csv_rnds.webp'
            alt='Imagem do relatório CSV de envios com sucesso da RNDS'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novo relatório gerencial de exames'
        id='relatorio-gerencial-exames-5-4'
        icon={<Relatorios css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsParagraph>
            Estamos disponibilizando um novo relatório gerencial que permite uma análise detalhada dos{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              exames solicitados e avaliados
            </Text>{' '}
            durante os atendimentos realizados. Este recurso foi desenvolvido para oferecer maior visibilidade e
            facilitar o acompanhamento de informações relacionadas aos exames.
          </NewsParagraph>
          <NewsList>
            <VFlow vSpacing={0.5}>
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Cobertura ampliada
                </Text>
                : Inclui os dados de exames registrados em atendimentos individuais e odontológicos do Prontuário
                Eletrônico, além das informações registradas no CDS.
              </NewsListItem>
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Compatibilidade com procedimentos odontológicos
                </Text>
                : Para os atendimentos odontológicos, considera procedimentos do grupo SIGTAP 02 - Procedimentos com
                finalidade diagnóstica, registrados no CDS e no odontograma do Prontuário Eletrônico.
              </NewsListItem>
              <NewsGif
                src='/static/novidades/5-4_relatorio_gerencial_exames_geracao.webm'
                pausedSrc='/static/novidades/5-4_relatorio_gerencial_exames_geracao_paused.webp'
                alt='Gif mostrando como gerar um relatório'
              />
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Análise por origem
                </Text>
                : Visualize o volume de exames solicitados e avaliados por meio do campo “Origem”.
              </NewsListItem>
              <NewsGif
                src='/static/novidades/5-4_relatorio_gerencial_exames_campo_origem.webm'
                pausedSrc='/static/novidades/5-4_relatorio_gerencial_exames_campo_origem_paused.webp'
                alt='Gif mostrando como utilização do campo de origem'
              />
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Exportação de dados
                </Text>
                : Permite a exportação dos resultados em arquivos CSV, garantindo maior flexibilidade no uso e
                compartilhamento das informações.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_relatorio_gerencial_exames_csv.webp'
                alt='Imagem exibindo a exportação do relatório para csv'
              />
            </VFlow>
          </NewsList>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novos gráficos para crianças, adolescentes e gestantes'
        icon={<Icon icon='balanceFilled' css={styles.iconSVG} />}
        id='graficos-criancas-adolescentes-gestantes-5-4'
      >
        <NewsSectionContent>
          <NewsListItem>
            Com foco no aprimoramento do acompanhamento nutricional, o sistema recebeu atualizações importantes nos
            gráficos de peso e altura para crianças e adolescentes, além da inclusão de gráficos específicos para o
            ganho de peso gestacional. As alterações seguem as diretrizes do Guia de Vigilância Alimentar e Nutricional
            na Atenção Primária à Saúde (APS).
          </NewsListItem>
          <NewsListItem>
            O gráfico de altura foi atualizado para adolescentes de 10 a 19 anos. A classificação para o gráfico de
            altura conta com as opções "adequado", "baixo" e "muito baixo". Sendo que as opções "muito elevado" e
            "elevado" não serão mais exibidas.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-4_grafico_altura_adolescentes.webp'
            alt='Imagem exibindo gráfico de altura para adolescentes'
          />
          <NewsListItem>
            Além disso, o sistema conta com os gráficos de peso e altura atualizados para crianças de 0 a 10 anos. A
            classificação para o gráfico de peso conta com as opções "elevado", "adequado", 'baixo" e "muito baixo".
            Sendo que a opção "muito elevado" não será mais exibida.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-4_grafico_peso_criancas.webp'
            alt='Imagem exibindo gráfico de peso para crianças'
          />
          <NewsListItem>
            A classificação para o gráfico de altura conta com as opções "adequado", "baixo" e "muito baixo". Sendo que
            as opções "muito elevado" e "elevado" não serão mais exibidas.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-4_grafico_altura_criancas.webp'
            alt='Imagem exibindo gráfico de altura para crianças'
          />
          <NewsListItem>
            Também o sistema agora conta com gráficos de ganho de peso específicos para acompanhar a evolução de acordo
            com o Índice de Massa Corporal (IMC) de referência da pessoa gestante. Essa funcionalidade estará disponível
            dentro da aba "Gestação", no card de "Medições", para gestantes que iniciaram o pré-natal no sistema.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-4_acesso_grafico_ganho_peso.webm'
            pausedSrc='/static/novidades/5-4_acesso_grafico_ganho_peso_paused.webp'
            alt='Gif mostrando como acessar o gráfico de ganho de peso gestacional'
          />
          <NewsListItem>
            Com essa atualização, o sistema exibirá um dos gráficos a seguir, conforme o IMC de referência da gestante:
          </NewsListItem>
          <NewsList>
            <VFlow vSpacing={0.5}>
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Baixo Peso:
                </Text>{' '}
                IMC menor que 18,5 kg/m²
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_grafico_ganho_peso_baixopeso.webp'
                alt='Imagem exibindo gráfico de ganho de peso para gestantes com baixo peso'
              />
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Eutrofia:
                </Text>{' '}
                IMC maior ou igual a 18,5 kg/m² e menor que 25 kg/m²
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_grafico_ganho_peso_eutrofia.webp'
                alt='Imagem exibindo gráfico de ganho de peso para gestantes com eutrofia'
              />
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Sobrepeso:
                </Text>{' '}
                IMC maior ou igual a 25 kg/m² e menor que 30 kg/m²
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_grafico_ganho_peso_sobrepeso.webp'
                alt='Imagem exibindo gráfico de ganho de peso para gestantes com sobrepeso'
              />
              <NewsListItem>
                <Text fontSize={0.875} fontWeight='bold'>
                  Obesidade:
                </Text>{' '}
                IMC maior ou igual a 30 kg/m²
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_grafico_ganho_peso_obesidade.webp'
                alt='Imagem exibindo gráfico de ganho de peso para gestantes com obesidade'
              />
            </VFlow>
          </NewsList>
          <NewsListItem>
            Para o cálculo do IMC de referência, o sistema considera a medição de peso e altura mais recente realizada
            até 2 meses antes do início da gestação. Caso não exista essa informação, considera-se a primeira medição de
            peso e altura realizada até a oitava semana após o início da gestação.
          </NewsListItem>
          <NewsListItem>
            As atualizações foram adaptadas do "Guia para a Organização da Vigilância Alimentar e Nutricional na Atenção
            Primária à Saúde, 2023".
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Novo módulo e melhorias no registro de Atividades coletivas'
        icon={<AtividadeColetivaIcon css={css(styles.iconSVG, styles.fillableIconSVG)} />}
        id='atividade-coletiva-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O registro de atividades coletivas passou por uma reestruturação completa, com a chegada de um novo módulo.
            Além de facilitar o preenchimento e a gestão dos registros, essa atualização trouxe novos recursos como
            temas aprimorados, filtros, observações por cidadão e visualização de registros de diferentes fontes.
          </NewsParagraph>
          <NewsParagraph>
            Com o objetivo de otimizar o preenchimento existente na ficha e trazer evoluções ao processo de registro de
            atividades coletivas nas unidades, o novo módulo conta com:
          </NewsParagraph>
          <NewsList>
            <VFlow vSpacing={0.5}>
              <NewsListItem>Separação dos registros em Reuniões e Atividade em saúde;</NewsListItem>
              <NewsListItem>
                Visualização de registros de atividade coletiva de toda localidade do profissional;
              </NewsListItem>
              <NewsListItem>
                Gestão da listagem de registros através dos filtros de profissional responsável, registros processados,
                período, tipo de atividade e equipe;
              </NewsListItem>
              <NewsListItem>Campo aberto para inclusão de anotações da atividade em saúde ou reunião;</NewsListItem>
              <NewsListItem>Preenchimento automático de dados do cidadão e do profissional;</NewsListItem>
              <NewsListItem>Cálculo e classificação automática de IMC;</NewsListItem>
              <NewsListItem>Inclusão de observações sobre cidadãos em registros de reunião.</NewsListItem>
            </VFlow>
          </NewsList>
          <NewsParagraph>Confira a nova visualização e gestão da listagem dos registros:</NewsParagraph>
          <NewsGif
            src='/static/novidades/5-4_listagem_atividade_coletiva.webm'
            pausedSrc='/static/novidades/5-4_listagem_atividade_coletiva_paused.webp'
            alt='Gif mostrando a visualização e gestão da listagem de registros de atividade coletiva no novo módulo do PEC'
          />
          <NewsParagraph>
            Agora, o registro das atividades está otimizado através do preenchimento automático de dados, além de contar
            com novo campo para detalhamento da atividade:
          </NewsParagraph>
          <NewsGif
            src='/static/novidades/5-4_registro_atividade_coletiva.webp'
            pausedSrc='/static/novidades/5-4_registro_atividade_coletiva_paused.webp'
            alt='Gif mostrando o registro de atividade coletiva no novo módulo do PEC'
          />
          <NewsParagraph>
            Além disso, os registros de reunião contam com uma nova seção para inclusão de observações sobre cidadãos
            que foram discutidas durante a reunião de equipe:
          </NewsParagraph>
          <NewsGif
            src='/static/novidades/5-4_observacoes_atividade_coletiva.webp'
            pausedSrc='/static/novidades/5-4_observacoes_atividade_coletiva_paused.webp'
            alt='Gif mostrando o registro de obsevações sobre cidadãos em registros de reunião de equipe'
          />

          <NewsParagraph>
            O novo módulo de Atividade coletiva também conta com atualizações no campo "Temas para saúde", que passa a
            ter novas regras específicas de habilitação e novas opções de conteúdo.
          </NewsParagraph>

          <NewsParagraph>Principais alterações:</NewsParagraph>
          <NewsList>
            <NewsListItem>
              Inclusão do campo <strong>Temas para saúde</strong> nos registros de reunião, habilitado apenas quando
              "Educação permanente" for o tema exclusivo da reunião.
            </NewsListItem>
            <NewsListItem>
              Novas opções de <strong>Temas para saúde</strong> adicionadas, tanto para os registros de reunião quanto
              para os de atividade em saúde: Amamentação e Alimentação complementar saudável.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-4_atualizacoes_temas_em_saude_atividade_coletiva.webp'
            pausedSrc='/static/novidades/5-4_atualizacoes_temas_em_saude_atividade_coletiva_paused.png'
            alt='Gif mostrando as atualizações em temas para saúde no módulo de Atividade coletiva'
          />
          <NewsParagraph>
            A listagem do módulo de Atividade coletiva passa a exibir também os registros anteriores ao seu lançamento,
            bem como os registros provenientes de outras fontes, como Registro de Atendimento Simplificado (RAS PEC),
            aplicativo e-SUS AC, CDS e sistemas de terceiros. Além disso, foram adicionados os filtros "Fonte dos
            registros" e "Origem", permitindo uma análise mais detalhada e uma gestão visual mais eficiente dos dados
            com base em suas respectivas origens.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_exibicao_registros_atividade_coletiva.webp'
              alt='Imagem exibindo registros no módulo de Atividade coletiva'
            />
            <CarouselItem
              image='/static/novidades/5-4_exibicao_registros_outras_fontes_atividade_coletiva.webp'
              alt='Imagem exibindo registros de outras fontes no módulo de Atividade coletiva'
            />
          </Carousel>
          <NewsParagraph>
            A listagem do Histórico do Cidadão passa a exibir novos registros e dados originados do módulo de Atividade
            coletiva. Dentre as principais atualizações, temos:
          </NewsParagraph>
          <NewsList>
            <NewsListItem>
              Exibição do campo de Anotações da atividade ao expandir o registro de Atividade coletiva, tanto para
              atividades em saúde quanto para atividades em reunião;
            </NewsListItem>
            <NewsListItem>
              Nova exibição de registros de reunião de equipe no Histórico do Cidadão para quando o mesmo for mencionado
              em alguma Observação sobre cidadão durante a atividade.
            </NewsListItem>
          </NewsList>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_ac_anotacoes_atividade_ao_expandir_acordeon.webp'
              alt='Anotações de Atividade ao Expandir Registro de Atividade coletiva'
            />
            <CarouselItem
              image='/static/novidades/5-4_ac_exibicao_registros_reuniao_historico_cidadao.webp'
              alt='Exibição de registros de reunião no histórico do cidadão'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Indicação de óbito na Garantia de acesso'
        icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
        id='indicacao-obito-ga-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora, os registros da Garantia de Acesso contam com uma nova indicação visual para sinalizar quando o
            cidadão está falecido. Essa melhoria visa evitar tentativas de agendamento de consultas para cidadãos
            falecidos, reduzindo erros e aumentando a clareza para os profissionais de saúde.
          </NewsParagraph>
          <NewsList>
            <NewsListItem>Principais atualizações:</NewsListItem>
            <NewsList>
              <NewsListItem>Indicação visual de óbito nos registros da Garantia de Acesso.</NewsListItem>
              <NewsListItem>
                Bloqueio da funcionalidade de agendamento para cidadãos falecidos, prevenindo tentativas indevidas.
              </NewsListItem>
              <NewsListItem>Novo motivo de remoção do registro: "Óbito do cidadão".</NewsListItem>
            </NewsList>
          </NewsList>
          <NewsImg
            src='/static/novidades/5-4_indicacao_obito_garantia_acesso.webp'
            alt='Imagem exibindo a indicação de óbito na Garantia de Acesso'
          />
          <NewsParagraph>
            Essas mudanças garantem que os registros representem a situação do cidadão, melhorando a gestão na Garantia
            de Acesso.
          </NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Atualização dos resultados de exames quantitativos'
        id='atualizacao-resultados-exm-qualitativos-5-4'
        icon={<Atendimento css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsList>
            <NewsListItem>
              Agora os exames Colesterol total, HDL, LDL, Dosagem de triglicerídeos e Creatinina passam a utilizar duas
              casas decimais após a vírgula tanto na inserção quanto na visualização dos resultados.
            </NewsListItem>
          </NewsList>
          <NewsImg
            src='/static/novidades/5-4_atualizacao_casas_decimais_resultados_exames.webp'
            alt='Imagem exibindo a adição de resultados de exames com casas decimais'
          />
          <NewsParagraph>Essa melhoria garante maior precisão no registro e na apresentação dos dados.</NewsParagraph>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Atualização do atendimento de vacinação e do modelo RIA'
        id='atualizacao-atendimento-vacinacao-5-4'
        icon={<Atendimento css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsList>
            <NewsListItem>
              O atendimento de vacinação foi atualizado para conter três novas informações: "Motivo de indicação",
              "Especialidade do profissional prescritor" e "Pesquisa clínica".
            </NewsListItem>
            <NewsListItem>
              O campo "Motivo de indicação" deve ser utilizado para registrar o CID-10 que representa o motivo pelo qual
              o cidadão foi vacinado. O Campo "Especialidade do profissional prescritor" deve ser utilizado para
              registrar o CBO do profissional que solicitou a vacinação do cidadão. Ambos os campos só estarão liberados
              no sistema caso a aplicação do imunobiológico possua o campo "Estratégia" com o valor "Especial", neste
              cenário ambos os campos tornam-se obrigatórios. Em outros cenários, os campos não devem estar habilitados
              para preenchimento.
            </NewsListItem>
          </NewsList>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_1.webp'
              alt='Imagem exibindo o modal de aplicação de vacina com os novos campos. Os campos Motivo de Indicação e
              Especialidade do profissional prescritor estão desabilitados, e uma hint indicando o motivo é exibida'
            />
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_2.webp'
              alt='Imagem exibindo o modal de aplicação de vacina com os novos campos. O Campo Estratégia está preenchido com
              o valor "Especial" e os campos Motivo de Indicação e Especialidade do profissional prescritor estão habilitados'
            />

            <CarouselItem
              image='/static/novidades/5-4_vacinacao_3.webp'
              alt='Exibição dos valores possiveis no campo de motivo da indicação'
            />
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_4.webp'
              alt='Exibição dos valores possíveis no campo de especialidade do profissional prescritor'
            />
          </Carousel>
          <NewsList>
            <NewsListItem>
              O campo "Pesquisa clínica" é obrigatório e caso seja preenchido com o valor "Sim" os seguintes campos
              serão liberados: "Anvisa protocolo estudo", "Anvisa protocolo versão" e "Anvisa número de registro".
            </NewsListItem>
          </NewsList>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_5.webp'
              alt='Modal de aplicacao de vacinação exibindo o campo de pesquisa clínica preenchido como "Sim" e os demais campos liberados para preenchimento'
            />
            <CarouselItem image='/static/novidades/5-4_vacinacao_6.webp' alt='Exibição dos novos campos em detalhe' />
          </Carousel>
          <NewsParagraph>
            Além disso, para cidadãos com o sexo "Feminino" ou "Indeterminado" torna-se obrigatório o preenchimento do
            campo "Maternal".
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_vacinacao_7.webp'
            alt='Imagem exibindo os novos valores do campo de Condições Maternais'
          />
          <NewsParagraph>
            O modelo de informação RIA foi atualizado para enviar os novos campos para a RNDS quando necessário.
          </NewsParagraph>
          <NewsParagraph>
            Atenção: A atualização dos campos para condição maternal tem impacto nos modelos salvos de relatórios
            gerenciais de vacinação que possuem ambos os campos de "Gestante" e "Puérpera". Nestes modelos, é necessário
            editar para incluir o campo de condição maternal com as informações relevantes ao modelo existente.
          </NewsParagraph>
          <NewsParagraph>O registro CDS de vacinação também exibe os novos campos.</NewsParagraph>
          <NewsParagraph>
            Além disso, foram incluídos os campos "Via de administração" e "Local de aplicação" na Ficha de Vacinação.
            Anteriormente, eles existiam apenas no PEC. Com esta atualização eles estarão disponíveis com o mesmo
            comportamento também no CDS.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_8.webp'
              alt='Imagem exibindo a tela de preenchimento de vacinação do CDS, exibindo os novos campos. Os campos Motivo de
              Indicação e Especialidade do profissional prescritor estão desabilitados'
            />
            <CarouselItem
              image='/static/novidades/5-4_vacinacao_9.webp'
              alt='Imagem exibindo a tela de preenchimento de vacinação do CDS, exibindo os novos campos. O Campo Estratégia
              está preenchido com o valor "Especial" e os campos Motivo de Indicação e Especialidade do profissional prescritor estão habilitados'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Atualização na exibição do IMC no atendimento de gestantes'
        id='atualizacao-imc-gestantes-5-4'
        icon={<Atendimento css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsParagraph>
            Foi atualizada a forma como o IMC é exibido no atendimento de gestantes. As mudanças visam garantir o uso
            correto do <strong>IMC pré-gestacional</strong>, evitando confusões com o IMC calculado durante a gestação,
            que não deve ser utilizado para análise clínica.
          </NewsParagraph>
          <NewsParagraph>
            <strong>Alterações realizadas:</strong>
          </NewsParagraph>
          <NewsListItem>
            Remoção do IMC calculado no momento atual do card de <strong>Medições</strong>;
          </NewsListItem>
          <NewsListItem>
            Criação de uma nova seção no card de <strong>Medições</strong> para exibir o{' '}
            <strong>IMC pré-gestacional</strong>;
          </NewsListItem>
          <NewsListItem>
            Inclusão de uma mensagem contextual nos campos de antropometria da aba <strong>Objetivo (SOAP)</strong>,
            informando que o IMC válido durante a gestação é o <strong>pré-gestacional</strong>.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-4_imc_para_gestantes.webp'
            alt='Imagem exibindo a exibição do IMC pré-gestacional no card de pré natal na lateral do atendimento de gestantes'
          />
          <Text fontSize={0.875} component='strong'>
            Como o IMC pré-gestacional é calculado?
          </Text>
          <NewsParagraph>Segue a mesma lógica usada no gráfico de ganho de peso gestacional:</NewsParagraph>
          <ol>
            <NewsListItem>
              O sistema busca o <strong>peso e altura</strong> registrados até <strong>2 meses antes da DUM</strong>{' '}
              (Data da Última Menstruação);
            </NewsListItem>
            <NewsListItem>
              Caso não existam registros nesse período, considerar o peso e altura registrados até{' '}
              <strong>8 semanas de idade gestacional</strong>;
            </NewsListItem>
            <NewsListItem>
              Os dados de peso e altura devem estar registrados <strong>juntos</strong>, ou seja, na{' '}
              <strong>mesma linha de antropometria</strong>.
            </NewsListItem>
          </ol>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Ajustes nos Gráficos de IMC e Peso durante a Gestação'
        id='ajustes-graficos-peso-imc-5-4'
        icon={<Atendimento css={css(styles.iconSVG, styles.fillableIconSVG)} />}
      >
        <NewsSectionContent>
          <NewsParagraph>
            O sistema foi atualizado para deixar de apresentar o IMC durante o atendimento de uma gestante. O gráfico de
            IMC, que pode ser acessado na lateral dos atendimentos através da aba Antropometria do histórico de
            medições, passa a ser exibido com uma faixa indicando que o período gestacional da cidadã. Nesse contexto,
            será apresentando apenas o IMC pré-gestacional. O sistema passa a exibir a seguinte mensagem informativa: "O
            IMC não é recomendado como indicador durante a gestação. Utilize o gráfico de ganho de peso para
            monitoramento adequado.".
          </NewsParagraph>
          <NewsParagraph>
            No gráfico de Peso, também foi adicionada faixa indicativa do período gestacional, além disso, o sistema
            passa a exibir a seguinte mensagem informativa: "O peso não é recomendado como indicador durante a gestação.
            Utilize o gráfico de ganho de peso para monitoramento adequado.".
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_grafico_imc_durante_gestacao.webp'
              alt='Gráfico do IMC adaptado a períodos de gestação.'
            />
            <CarouselItem
              image='/static/novidades/5-4_grafico_peso_durante_gestacao.webp'
              alt='Gráfico de peso adaptado a períodos de gestação'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Sistema de Suporte à Decisão Clínica'
        icon={<SdcIcon css={styles.iconSVG} />}
        id='suporte-decisao-clinica-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Agora o PEC conta com um sistema de Suporte à Decisão Clínica (SDC) que objetiva notificar os profissionais
            durante os atendimentos dos cidadãos. Os alertas apresentados por esse sistema servem de apoio à tomada de
            decisão e não possuem caráter prescritivo por si só.
          </NewsParagraph>
          <NewsParagraph>Como funciona?</NewsParagraph>
          <NewsParagraph>
            <Text fontWeight='bold'>Alertas de apoio à tomada de decisão:</Text> Com base nas informações clínicas e
            avaliação inseridas pelo profissional, o sistema pode gerar alertas e sugerir possíveis diagnósticos, além
            de recomendar a conduta adequada, fornecendo suporte para decisões mais seguras e embasadas.
          </NewsParagraph>
          <NewsParagraph>
            <Text fontWeight='bold'>Automatização de condutas:</Text> O sistema disponibiliza condutas automatizadas com
            base em protocolos clínicos atualizados. O profissional pode optar por aplicar a conduta na totalidade ou em
            partes, editando as informações conforme necessário para cada caso específico.
          </NewsParagraph>
          <NewsParagraph>
            É fundamental que o profissional avalie se as informações fornecidas pelo SDC se aplicam ao caso clínico do
            cidadão, pois as recomendações e condutas não têm caráter prescritivo.
          </NewsParagraph>
          <NewsParagraph>
            Até o momento foram implementados alertas focados em casos de dengue. A funcionalidade será expandida para
            incluir outros protocolos clínicos, proporcionando um suporte cada vez mais completo nos atendimentos.
          </NewsParagraph>
          <NewsParagraph>
            Sempre que houver um novo alerta ou fluxo do SDC as novidades da versão explicarão as condições de disparo
            de cada alerta/fluxo.
          </NewsParagraph>

          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_sdc-icone.webp'
              alt='Imagem do ícone do Suporte à Decisão Clínica no atendimento'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-toast.webp'
              alt='Imagem do toast de alerta do Suporte à Decisão Clínica'
            />
          </Carousel>
          <NewsParagraph>
            Além disso, pensando em melhorar a experiência do usuário, o SDC possui um alerta informativo sobre como a
            ferramenta funciona.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-4_sdc_modal_suporte_decisao_clinica.webp'
            alt='Modal do sistema de Suporte à Decisão Clínica, com explicação sobre alertas e automatização de condutas para auxiliar profissionais de saúde.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Suporte à Decisão Clínica - Alerta de condutas recomendadas para dengue'
        icon={<SdcIcon css={styles.iconSVG} />}
        id='suporte-decisao-clinica-conduta-dengue-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O Suporte à Decisão Clínica irá disparar alguns alertas quando o usuário registra um CIAP-2 ou CID-10 de
            dengue.
          </NewsParagraph>
          <NewsParagraph>
            Os <Text fontWeight='bold'>alertas de condutas recomendadas para dengue</Text> são exibidos quando o usuário
            registra alguma das seguintes condições no campo "Problemas e/ou condições avaliados neste atendimento":
          </NewsParagraph>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader>Condições do fluxo</TableHeader>
                <TableHeader>Alerta</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{ padding: '16px 16px' }}>
                  Registro no atendimento atual de Dengue [Dengue Clássico] - (<Text fontWeight='bold'>CID A90</Text>
                  ), Febre Hemorrágica devida ao Vírus do Dengue - (<Text fontWeight='bold'>CID A91</Text>) ou Dengue e
                  outras doenças virais NE - (<Text fontWeight='bold'>CIAP A77</Text>).
                </TableCell>
                <TableCell>Cidadão com CIAP-2 ou CID-10 de dengue identificado.</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <NewsParagraph>
            Em conjunto com o alerta "Cidadão com CIAP-2 ou CID-10 de dengue identificado." serão exibidos no SDC as
            condutas recomendas para os estadiamentos do grupo A, B, C e D da dengue.
          </NewsParagraph>

          <NewsParagraph>
            Quando um profissional de saúde registrar{' '}
            <Text fontWeight='bold'>Dengue [Dengue Clássico] - (CID A90)</Text> ou{' '}
            <Text fontWeight='bold'>Dengue e outras doenças virais NE - (CIAP A77)</Text>, o sistema exibirá uma
            mensagem no <Text fontWeight='bold'>Plano</Text>, permitindo o acesso à opção{' '}
            <Text fontWeight='bold'>"Visualizar conduta completa da dengue"</Text>. Ao clicar nessa opção, o usuário
            será redirecionado para os alertas emitidos no <Text fontWeight='bold'>Suporte à Decisão Clínica</Text>.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-4_sdc-flux-alerta-conduta-dengue.webm'
              alt='Gif do alerta da conduta da dengue disparado pelo Suporte à Decisão Clínica'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-alerta-conduta-dengue.webp'
              alt='Imagem do alerta de dengue disparado pelo Suporte à Decisão Clínica'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-alerta-conduta-dengue-grupo-A.webp'
              alt='Imagem do alerta de dengue do grupo A disparado pelo Suporte à Decisão Clínica'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-alerta-conduta-dengue-grupo-B.webp'
              alt='Imagem do alerta de dengue do grupo B disparado pelo Suporte à Decisão Clínica'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-alerta-conduta-dengue-grupo-C.webp'
              alt='Imagem do alerta de dengue do grupo C disparado pelo Suporte à Decisão Clínica'
            />
            <CarouselItem
              image='/static/novidades/5-4_sdc-alerta-conduta-dengue-grupo-D.webp'
              alt='Imagem do alerta de dengue do grupo D disparado pelo Suporte à Decisão Clínica'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Suporte à Decisão Clínica - Botão "Aplicar conduta recomendada" para dengue'
        icon={<SdcIcon css={styles.iconSVG} />}
        id='suporte-decisao-clinica-botao-para-aplicar-conduta-recomendada-para-dengue-5-4'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O Suporte à Decisão Clínica disponibiliza o botão "Aplicar conduta recomendada" quando o usuário registra um
            CIAP-2 ou CID-10 de dengue.
          </NewsParagraph>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader>Condições do fluxo</TableHeader>
                <TableHeader>Evento</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  Registro no atendimento atual de Dengue [Dengue Clássico] - (
                  <Text fontSize={0.875} fontWeight='bold' component='strong'>
                    CID A90
                  </Text>
                  ) ou Dengue e outras doenças virais NE - (
                  <Text fontSize={0.875} fontWeight='bold' component='strong'>
                    CIAP A77
                  </Text>
                  ).
                </TableCell>
                <TableCell>Mensagem e botão liberado na seção do "Plano".</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <NewsParagraph>A seguinte mensagem será exibida na seção "Plano":</NewsParagraph>
          <NewsList>
            <Text fontSize={0.875} display='block' component='li'>
              Título:{' '}
              <Text fontSize={0.875} fontWeight='bold' component='strong'>
                Conduta recomendada do SDC.
              </Text>
            </Text>
            <Text fontSize={0.875} display='block' component='li'>
              Subtítulo:{' '}
              <Text fontSize={0.875} fontWeight='bold' component='strong'>
                Cidadão com CIAP-2 ou CID-10 de dengue identificado.
              </Text>
            </Text>
            <Text fontSize={0.875} display='block' component='li'>
              Texto: O Suporte à Decisão Clínica disponibiliza a conduta completa para dengue e permite automatizar
              ações essenciais no atendimento, conforme as recomendações do Ministério da Saúde. Clique no botão abaixo
              para visualizar a conduta recomendada e decidir se deseja aplicá-la.
            </Text>
          </NewsList>
          <NewsImg
            src='/static/novidades/5-4_sdc_mensagem_aplicar_conduta_recomendada.webp'
            alt='Mensagem do sistema de Suporte à Decisão Clínica exibida na seção "Plano".'
          />
          <NewsParagraph>
            O botão "Aplicar conduta recomendada" possui as opções "Grupo A" e "Grupo B", onde o usuário poderá escolher
            automatizar as prescrições de medicamentos, solicitação de exames, geração de atestado, e preenchimento do
            campo de "Orientações ao cidadão" da aba Orientações. Todos os registros seguem protocolos preestabelecidos
            do Ministério da Saúde.
          </NewsParagraph>
          <NewsParagraph>
            Após aplicar a conduta, é recomendável revisar os registros feitos automaticamente. Se necessário, é
            possível editá-los antes de imprimir e entregar ao cidadão.
          </NewsParagraph>
          <NewsGif
            src='/static/novidades/5-4_fluxo_para_aplicar_conduta_recomendada_dengue.webm'
            pausedSrc='/static/novidades/5-4_fluxo_para_aplicar_conduta_recomendada_dengue_static.webp'
            alt='Fluxo para aplicar conduta recomendada para dengue sugerida pelo sistema de Suporte à Decisão Clínica'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      {PILOTO_PRESCRICAO_CONTROLADA_ENABLED && (
        <NewsHeadingSection
          title='Prescrição digital de medicamentos controlados'
          icon={<Consulta css={styles.iconSVG} />}
          id='prescricao-digital-controlada-5-4'
        >
          <NewsSectionContent>
            <NewsList>
              <NewsListItem>
                Atualmente, instalações que possuem a assinatura digital ativa permitem que, para medicamentos de uso
                comum, sejam emitidas <strong>prescrições digitais</strong>, que são assinadas digitalmente e enviadas
                via <strong>e-mail</strong> para os cidadãos.
              </NewsListItem>
              <NewsListItem>
                Agora será possível emitir prescrições digitais para alguns medicamentos de uso{' '}
                <strong>controlado</strong>, utilizando um <strong>certificado digital</strong> para realizar a
                assinatura da prescrição.
              </NewsListItem>
              <NewsListItem>
                Medicamentos que ainda não podem ser incluídos em uma prescrição digital serão apresentados na seção{' '}
                <i>"Medicamentos não permitidos na prescrição digital"</i>.
              </NewsListItem>
            </NewsList>
            <NewsGif
              src='/static/novidades/5-4_prescricao_digital_controlada.webm'
              pausedSrc='/static/novidades/5-4_prescricao-digital-controlada.webp'
              alt='Gif mostrando como utilizar a prescrição digital de medicamentos.'
            />
          </NewsSectionContent>
        </NewsHeadingSection>
      )}

      {PROGRAMA_DIGNIDADE_MENSTRUAL_ENABLED && (
        <NewsHeadingSection
          title='Autorização para retirada de absorventes'
          icon={<ProgramaDignidadeMenstrual css={styles.noMarginUl} />}
          id='programa-dignidade-menstrual-5-4'
        >
          <NewsSectionContent>
            <NewsList>
              <NewsListItem>
                O <strong>Programa Dignidade Menstrual</strong> é uma ação do Governo Federal ao combate à precariedade
                menstrual e uma das estratégias do programa é a oferta gratuita de absorventes higiênicos, que são
                ofertados a cidadãos que atendem a alguns critérios. Para retirar os absorventes, os cidadãos devem
                possuir um documento de autorização.
              </NewsListItem>
              <NewsListItem>
                Agora será possível <strong>gerar o documento de autorização para retirada de absorventes</strong>{' '}
                através da lista de cidadãos e da lista de atendimentos do e-SUS APS para cidadãos que atendem aos
                critérios do programa.
              </NewsListItem>
            </NewsList>
            <NewsGif
              src='/static/novidades/5-4_gerar-documento-dignidade-menstrual.webm'
              pausedSrc='/static/novidades/5-4_gerar-documento-dignidade-menstrual.webp'
              alt='Gif mostrando como gerar o documento de dignidade menstrual'
            />
            <NewsList>
              <NewsListItem>
                Para que seja possível emitir o documento, o serviço “Programa de Dignidade Menstrual” deve estar{' '}
                <strong>habilitado</strong> no município, através da configuração de certificados em “Gestão Municipal”.
              </NewsListItem>
            </NewsList>
          </NewsSectionContent>
        </NewsHeadingSection>
      )}
    </Fragment>
  )
}

const styles = {
  iconSVG: css`
    margin-right: 0.25rem;
    width: 2rem;
    height: 2rem;
  `,
  fillableIconSVG: css`
    fill: ${gray.c60};
  `,
  noMarginUl: css`
    margin: 0;
  `,
  noPaddingUl: css`
    padding: 0;
  `,
}
